import styled from 'styled-components'

export const Container = styled.div`
	position: relative;
	background-color: ${(props) => props.theme.primary};
	height: 100px;
	width: 100%;
	z-index: 100;
	display: flex;
	justify-content: center;
	align-items: center;
	padding-left: 10px;
	padding-right: 10px;

	@media (max-width: 600px) {
		display: block;
		text-align: center;
		height: 150px;
		justify-content: center;
	}
`
export const ConnectContainer = styled.div`
	padding: 10px;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;

	@media (max-width: 600px) {
		width: 100%;
		height: auto;
	}
`
export const Contact = styled.p`
	color: ${(props) => props.theme.white};
	margin-top: 0px;
	margin-bottom: 5px;
	text-align: center;
`
export const EmailLinke = styled.a`
	color: ${(props) => props.theme.white};
`
export const CopyrightCopy = styled.p`
	margin-top: 0px;
	margin-bottom: 10px;
	font-size: 16px;
	line-height: 1;
	color: ${(props) => props.theme.white};
	text-align: center;
	font-weight: 300;
`
